
let hiddenProfileItems = [];
let currentPoint = null;

function getCoordinates(e, svg) {
    currentPoint.x = e.clientX;
    currentPoint.y = e.clientY;
    return currentPoint.matrixTransform(svg.getScreenCTM().inverse());
}

function Item(config) {
    Object.keys(config).forEach(function (item) {
      this[item] = config[item];
    }, this);
    this.el.addEventListener('mousemove', this.mouseMoveHandler.bind(this));
    this.el.addEventListener('touchmove', this.touchMoveHandler.bind(this));
}

Item.prototype = {
    update: function update(c) {
      this.clip.setAttribute('cx', c.x);
      this.clip.setAttribute('cy', c.y);
    },
    mouseMoveHandler: function mouseMoveHandler(e) {
      this.update(getCoordinates(e, this.svg));
    },
    touchMoveHandler: function touchMoveHandler(e) {
      e.preventDefault();
      var touch = e.targetTouches[0];
      if (touch) return this.update(getCoordinates(touch, this.svg));
    }
};

function InitMouseMode() {
  const hiddenProfiles = Array.from(document.querySelectorAll('.team_members .hidden-profile.mouse'));
    if (hiddenProfiles.length === 0) return;
    
    currentPoint = hiddenProfiles[0].querySelector('svg').createSVGPoint();

    hiddenProfiles.forEach((hiddenProfile, index) => {
        hiddenProfileItems.push(new Item({
            el: hiddenProfile,
            svg: hiddenProfile.querySelector('svg'),
            clip: document.querySelector(`#clip-${index} circle`)
        }));
    });
}

function InitTouchMode() {
  const hiddenProfiles = Array.from(document.querySelectorAll('.team_members .hidden-profile.touch'));
  if (hiddenProfiles.length === 0) return;

  hiddenProfiles.forEach((hiddenProfile) => {
    hiddenProfile.addEventListener('click', () => {
      hiddenProfile.classList.toggle('active');
    });
  });
}

export default function InitHiddenProfilePictures() {
    const touchQuery = window.matchMedia('(pointer: coarse)');
    const mouseQuery = window.matchMedia('(pointer: fine)');

    if (mouseQuery.matches) InitMouseMode();
    else if (touchQuery.matches) InitTouchMode();
}